/**
 * Sticky navbar + scroll-to-top behavior
 */

const STICKY_CLASS = 'navbar--sticky';
const VISIBLE_CLASS = 'visible';

export function initNavbar() {
  const navbar = document.getElementById('main-navbar');
  const btnTop = document.getElementById('btnScrollTop');

  if (!navbar) return;

  // Sticky on scroll
  const onScroll = () => {
    const scrolled = window.scrollY > 80;
    navbar.classList.toggle(STICKY_CLASS, scrolled);
    if (btnTop) btnTop.classList.toggle(VISIBLE_CLASS, window.scrollY > 400);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run once on load

  // Back-to-top click
  btnTop?.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  // Close mobile menu when a link is clicked (UX improvement)
  const navLinks = navbar.querySelectorAll('.nav-link:not(.dropdown-toggle)');
  const collapseEl = document.getElementById('navbarMain');
  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      if (collapseEl?.classList.contains('show')) {
        const bsCollapse = bootstrap.Collapse.getInstance(collapseEl);
        bsCollapse?.hide();
      }
    });
  });
}
